import CheckCircleOutlined from '@mui/icons-material/CheckCircleOutlined';
import FlagOutlined from '@mui/icons-material/FlagOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';
import { PRIMARY_PILL_SX } from './Pill.js';

export interface GoalProgress {
  name: string;
  step: number;
  total: number;
  next: string | null;
}

export function GoalChip({ progress }: { progress: GoalProgress }): ReactNode {
  const reached = progress.next === null;
  const Icon = reached ? CheckCircleOutlined : FlagOutlined;
  return (
    <Stack
      direction="row"
      data-testid="workflow-goal"
      sx={[
        PRIMARY_PILL_SX,
        { gap: 1, px: 2, py: 1, alignItems: 'center', borderRadius: 1 },
        reached ? { bgcolor: 'success.bg', color: 'success.main' } : {},
      ]}
    >
      <Icon sx={{ fontSize: 14 }} />
      <Typography sx={{ fontSize: 12, fontWeight: 600 }}>
        {reached ? `Goal reached: ${progress.name}` : `Goal: ${progress.name}`}
      </Typography>
      {reached ? null : (
        <Typography sx={{ fontSize: 12 }}>
          · Step {progress.step + 1} of {progress.total}
        </Typography>
      )}
    </Stack>
  );
}
